// extracted by mini-css-extract-plugin
export default {"main":"SimpleLayout_main__mS4IC","container":"SimpleLayout_container__da7hk"};